import React from "react";

export default function SmartImage({
  loading = "lazy",
  decoding = "async",
  alt,
  ...props
}) {
  return <img loading={loading} decoding={decoding} alt={alt} {...props} />;
}

